function getDoclingUrl() {
  return (
    (typeof process !== "undefined" && process.env?.DOCLING_URL) ||
    "http://127.0.0.1:5001"
  );
}

// ---------- File type classification ----------

const BINARY_MIME_TYPES = new Set([
  "application/pdf",
  "application/vnd.openxmlformats-officedocument.wordprocessingml.document",
  "application/vnd.openxmlformats-officedocument.presentationml.presentation",
  "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
  "image/png",
  "image/jpeg",
  "image/tiff",
]);

const TEXT_MIME_TYPES = new Set(["text/plain", "text/markdown"]);

export const SUPPORTED_MIME_TYPES = new Set([
  ...BINARY_MIME_TYPES,
  ...TEXT_MIME_TYPES,
]);

export function isBinaryFormat(mimeType: string): boolean {
  return BINARY_MIME_TYPES.has(mimeType);
}

export function isTextFormat(mimeType: string): boolean {
  return TEXT_MIME_TYPES.has(mimeType);
}

export function isSupportedFormat(mimeType: string): boolean {
  return SUPPORTED_MIME_TYPES.has(mimeType);
}

// ---------- Health check ----------

export async function checkDoclingHealth(): Promise<{
  ok: boolean;
  error?: string;
}> {
  try {
    const controller = new AbortController();
    const timeout = setTimeout(() => controller.abort(), 5_000);
    const res = await fetch(`${getDoclingUrl()}/health`, {
      signal: controller.signal,
    });
    clearTimeout(timeout);
    if (res.ok) {
      return { ok: true };
    }
    return { ok: false, error: `HTTP ${res.status}` };
  } catch (err) {
    return {
      ok: false,
      error: err instanceof Error ? err.message : String(err),
    };
  }
}
